@if (hasJoinRequestId) {
  <lib-baa-request-flow />
} @else {
  <lib-ffd-notes-invite-welcome />
}
